import React, { useEffect, createElement } from 'react'
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import Content from '../../../layout/Content'
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { clearLegalManifestCargos, generateManifestCargoFile, getLegalManifestCargos, getManifestCargoExportExcel } from '../../../../actions/legal/LegalManifestCargo';
import LegalManifestCargoForm from './LegalManifestCargoForm';
import Table from '../../../common/Table';
import { DEFAULT_PAGE_SIZE, LEGAL_SOURCE_SYSTEM } from '../../../../config/constants';
import { INT_DATE_FORMAT } from '../../../../config/locale';
import { tzNormalizeDate } from '../../../../utils/date';
import LegalManifestCargoDetail from './LegalManifestCargoDetail';
import { generateLegalManifestCargoColumns } from '../../../../config/columns';

const LegalManifestCargos = ({
  breadcrumbs,
  dispatchGetLegalManifestCargos,
  legalManifestCargos,
  loading,
  dispatchClearLegalManifestCargos,
  dispatchGenerateManifestCargoFile,
  dispatchGetManifestCargoExportExcel
}) => {

  useEffect(() => () => dispatchClearLegalManifestCargos(), []);

  const renderManifestDetailComponent = ({ original }) => {
    const component = createElement(LegalManifestCargoDetail, {
      manifestId: original.id,
      sourceSystem: original.sourceSystem,
      manifestCode: original.manifestCode,
      betterezManifestId: original.betterezManifestId,
    })
    return (
      <div className="mt-3 mb-2 ml-5 mr-5">
        {component}
      </div>
    );
  }

  const onSubmit = (formValues) => {

    const { fromDateString, toDateString, busLicensePlate } = formValues;

    const startDate = tzNormalizeDate({
      date: fromDateString,
      format: INT_DATE_FORMAT,
    });

    const endDate = tzNormalizeDate({
      date: toDateString,
      format: INT_DATE_FORMAT,
    });

    const newFormValues = {
      licensePlate: busLicensePlate,
      startDate,
      endDate,
    }

    if (formValues.sourceCity && formValues.sourceCity.value) {
      newFormValues.sourceCityId = formValues.sourceCity.value;
    }

    if (formValues.destinationCity && formValues.destinationCity.value) {
      newFormValues.destinationCityId = formValues.destinationCity.value;
    }

    dispatchGetLegalManifestCargos(newFormValues);
  }

  const handleAcction = ({ original: manifest }) => {
    const { idSourceSystem } = manifest;

    const system = idSourceSystem.split('-')[0];
    const id = idSourceSystem.split('-')[1];

    if (system === LEGAL_SOURCE_SYSTEM.FLIT.value) {
      dispatchGenerateManifestCargoFile(id);
      return
    }

    dispatchGetManifestCargoExportExcel(idSourceSystem);
  }

  const content = (
    <>
      <LegalManifestCargoForm onSubmit={onSubmit} loading={loading} />
      <h3>Resultados de manifiestos de Carga</h3>
      <Table
        manual={false}
        columns={generateLegalManifestCargoColumns(handleAcction)}
        data={legalManifestCargos.toJS()}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        rowComponent={renderManifestDetailComponent}
        loading={loading}
      />
    </>
  )

  return (
    <Content
      title='Manifiesto de Carga'
      text='Consulta de manifiesto de carga'
      breadcrumbs={breadcrumbs}
      content={content}
    />
  )
}

LegalManifestCargos.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetLegalManifestCargos: PropTypes.func.isRequired,
  dispatchClearLegalManifestCargos: PropTypes.func.isRequired,
  legalManifestCargos: PropTypes.instanceOf(Immutable.List).isRequired,
  loading: PropTypes.bool,
  dispatchGenerateManifestCargoFile: PropTypes.func.isRequired,
  dispatchGetManifestCargoExportExcel: PropTypes.func.isRequired,
};

LegalManifestCargos.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ LegalUnit }) => ({
  breadcrumbs: [
    ...LegalUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Manifiesto de Carga',
      href: '',
    },
  ],
  loading: LegalUnit.LegalManifestCargo.getIn(['all', 'loading']),
  legalManifestCargos: LegalUnit.LegalManifestCargo.getIn(['all', 'content']),
});

const mapDispatchToProps = {
  dispatchGetLegalManifestCargos: getLegalManifestCargos,
  dispatchClearLegalManifestCargos: clearLegalManifestCargos,
  dispatchGenerateManifestCargoFile: generateManifestCargoFile,
  dispatchGetManifestCargoExportExcel: getManifestCargoExportExcel
};

export default connect(mapStateToProps, mapDispatchToProps)(LegalManifestCargos);